import request from '@/utils/request'

export interface PrintJobSubmitResponse {
  jobId: string
  queued: boolean
}

export interface PrintAgentStatusResponse {
  online: boolean
  lastHeartbeatEpochMillis?: number
}

export interface PrintJobStatusResponse {
  jobId: string
  status: string
  errorMessage?: string
}

export const submitPrintJob = (data: {
  payloadBase64: string
  shopKey?: string
  orderNumber?: string
}) =>
  request({
    url: '/print/jobs',
    method: 'post',
    data,
  })

export const getPrintAgentStatus = (shopKey?: string) =>
  request({
    url: '/print/agent-status',
    method: 'get',
    params: shopKey ? { shopKey } : {},
  })

export const getPrintJobStatus = (jobId: string) =>
  request({
    url: `/print/jobs/${jobId}`,
    method: 'get',
  })
